import { defineComponent as _defineComponent } from 'vue'
import { PaginatedResponse } from 'ah-api-gateways';
import { PropType, computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ListPageCounter',
  props: {
  data: {
    type: Object as PropType<PaginatedResponse<any>>,
    required: true,
  },
},
  setup(__props) {

const props = __props;



const rangeMin = computed(() => Math.max(props.data.pageSize || 10, 1) * Math.max(props.data.pageNumber || 0, 0) + 1);
const rangeMax = computed(() =>
  Math.min(
    Math.max(props.data.pageSize || 10, 1) * (Math.max(props.data.pageNumber || 0, 0) + 1),
    props.data.total || 0
  )
);

return { __sfc: true,props, rangeMin, rangeMax }
}

})